
export const State = {
  futureDate: ''
}

export const Mutations = {
  saveDate(state, date) {
    state.futureDate = date
  }
}

export const Actions = {
  saveDate({ commit }, date) {
    commit('saveDate', date)
  }
}
